import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'imageBase64Content',
  standalone: true
})
export class ImageBase64ContentPipe implements PipeTransform {

  transform(value: unknown, contentType: string): unknown {
    return `data:${contentType};base64,${value}`;
  }

}
